<div class="block--content block" id="main-content" *ngIf="!env.CHANGE_PASSWORD_NEW; else changePasswordV2">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>

        <ion-button (click)="back()" color="secondary" fill="clear">
            <ion-icon
                class="mr-1 text-xl dark:filter-yellow"
                src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg">
            </ion-icon>
            <span class="vl-app-light:hidden">{{ 'RELATED_CARD_DETAIL_BACK_LINK' | translate }}</span>
        </ion-button>

        <div class="ticket">
            <ridango-customer-account-change-password-aside></ridango-customer-account-change-password-aside>
            <rwidget-customer-account-change-password (saveSuccess)="handleSaveSuccess()">
            </rwidget-customer-account-change-password>
        </div>
    </div>
</div>

<ng-template #changePasswordV2>
    <rwidget-alert></rwidget-alert>
    <rwidget-customer-account-change-password-v2
        (saveSuccess)="handleSaveSuccess()"
        (backRouteEmit)="back()"></rwidget-customer-account-change-password-v2>
</ng-template>
